const EmployeesData = [
{
name: "Ali Raza",
position: "Sales Man",
value: "3"
},


{
    name: "Amjad",
    position: "Sales Man",
    value: "2"
    },


    {
        name: "Babar Ali",
        position: "Sales Man",
        value: "5"
        },

        {
            name: "Umer",
            position: "Sales Man",
            value: "5"
            },
            {
                name: "Danish",
                position: "Sales Man",
                value: "4"
                },

                {
                    name: "Ahmad Ali",
                    position: "Sales Man",
                    value: "5"
                    },

                    {
                        name: "Mustafa",
                        position: "Sales Man",
                        value: "4"
                        },

                        {
                            name: "Hassan Ali",
                            position: "Sales Man",
                            value: "4"
                            },

                          

                                {
                                    name: "Usman",
                                    position: "Sales Man",
                                    value: "3"
                                    },

                                    {
                                        name: "Qasim",
                                        position: "Sales Man",
                                        value: "4"
                                        },

]


export default EmployeesData;